var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_7515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 1.2041C4.23607 1.2041 0.375948 4.20439 0.375948 7.90723C0.375948 9.44218 1.04674 10.8479 2.15856 11.9742C1.65723 13.2472 0.613135 14.3229 0.596289 14.3348C0.373084 14.5604 0.314124 14.8907 0.440467 15.1727C0.571048 15.4547 0.859514 15.6416 1.18362 15.6416C3.25565 15.6416 4.85936 14.8118 5.8701 14.1511C6.81346 14.4428 7.89832 14.6104 9.00003 14.6104C13.764 14.6104 17.5947 11.6091 17.5947 7.90723C17.5947 4.20536 13.764 1.2041 9.00003 1.2041ZM9.0034 13.0635C8.10215 13.0635 7.21371 12.9305 6.36267 12.6729L5.59619 12.4433L4.93921 12.8864C4.4591 13.2125 3.79774 13.5754 3.00195 13.821C3.25042 13.4304 3.4861 12.9911 3.67173 12.5238L4.02954 11.6215L3.33482 10.9167C2.72736 10.2952 1.99458 9.26719 1.99458 7.90723C1.99458 5.06323 5.1363 2.75098 9.00239 2.75098C12.8685 2.75098 16.0102 5.06323 16.0102 7.90723C16.0102 10.7512 12.8678 13.0635 9.0034 13.0635Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_7515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.25,
    height: 16.5,
    fill: "white",
    transform: "translate(0.375 0.172852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentRegular);
export default __webpack_public_path__ + "static/media/comment-regular.034723283357e90cee921a4cf118fde0.svg";
export { ForwardRef as ReactComponent };